import React, { Component } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faLongArrowAltRight,
  faLongArrowAltLeft,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
library.add(faLongArrowAltRight, faLongArrowAltLeft);

class StepButton extends Component {
  saveAndContinue = (e) => {
    e.preventDefault();
    this.props.nextStep();
  };

  back = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  finish = (e) => {
    e.preventDefault();
    this.props.completedStep();
  };

  render() {
    let currentStep = this.props.currentStep;
    let totalStep = this.props.totalStep;
    let prevousButton;
    let nextButton;
    if (currentStep !== 1) {
      prevousButton = (
        <button
          type='button'
          className='button btn-navy-outline'
          onClick={this.back}
        >
          <FontAwesomeIcon icon={faLongArrowAltLeft} /> &nbsp; Back
        </button>
      );
    }

    if (currentStep !== totalStep) {
      nextButton = (
        <button
          type='button'
          className='button btn-main'
          onClick={this.saveAndContinue}
        >
          Continue &nbsp;
          <FontAwesomeIcon icon={faLongArrowAltRight} />
        </button>
      );
    } else {
      nextButton = (
        <button
          type='button'
          className='button btn-main'
          // Commit this part out if you want to use the form capture function
          onClick={this.finish}
        // Use save and continues instead of finish if capture form is included
        //onClick={this.saveAndContinue}
        >
          Calculate &nbsp;
          <FontAwesomeIcon icon={faLongArrowAltRight} />
        </button>
      );
    }

    return (
      <form className="hide-on-print">
        {prevousButton}
        &nbsp;&nbsp;&nbsp;&nbsp;
        {nextButton}
      </form>
    );
  }
}

export default StepButton;
